import { IconEdit } from 'braid-design-system';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import type { ClientListingForListingsTab } from 'src/types/graphql-derived';
import { createEditListingUrl } from 'src/utils';

import Action from './Action';

interface EditActionProps {
  listing: ClientListingForListingsTab;
  onClick: () => void;
}

export const EditAction = ({ listing, onClick }: EditActionProps) => (
  <ExternalLink
    destination={createEditListingUrl(
      String(listing.clientId),
      String(listing.id),
    )}
  >
    <Action Icon={IconEdit} action="Edit" onClick={onClick} />
  </ExternalLink>
);
